
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("i5FAK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $05a216e053f3fb99$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PANEL_ID", () => (parcelRequire("ham2H")).PANEL_ID);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => (parcelRequire("ham2H")).SIDEBAR_WIDTH);
$parcel$export(module.exports, "useSetProjectListRightPanelState", () => (parcelRequire("jwXVX")).useSetProjectListRightPanelState);

var $dpe9O = parcelRequire("dpe9O");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $1KdDN = parcelRequire("1KdDN");

var $dfP3D = parcelRequire("dfP3D");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $ham2H = parcelRequire("ham2H");

var $eHwMr = parcelRequire("eHwMr");

var $jwXVX = parcelRequire("jwXVX");
const $05a216e053f3fb99$var$JiraProjectsTemplateListRightPanel = ({ queries: { templatesQueryRef: templatesQueryRef }, props: { sidebarRefreshEnabled: sidebarRefreshEnabled } })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const rootQueryRef = (0, $j4oe4.usePreloadedQuery)((0, $dpe9O.default), templatesQueryRef);
    const { jira: jira } = rootQueryRef;
    const isAnonymous = templatesQueryRef?.variables.isAnonymous;
    const shouldDisplayCreateProject = (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates') ? jira?.shouldDisplay : jira?.canCreateProject;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (isAnonymous || !jira) return;
        if (!(typeof jira?.sidebarExperimentTemplates?.totalCount === 'number') || !(jira?.sidebarExperimentTemplates?.totalCount > 0) || !jira?.userPreferences?.projectListRightPanelState || !shouldDisplayCreateProject) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarEligibility failed');
            return;
        }
        if (jira?.userPreferences?.projectListRightPanelState === 'OPEN') openRightSidebar((0, $ham2H.PANEL_ID), sidebarRefreshEnabled ? (0, $ham2H.SIDEBAR_WIDTH_REFRESH) : (0, $ham2H.SIDEBAR_WIDTH), false, true);
        if (jira?.userPreferences?.projectListRightPanelState === 'CLOSED') closeRightSidebar((0, $ham2H.PANEL_ID));
    }, [
        openRightSidebar,
        closeRightSidebar,
        createAnalyticsEvent,
        isAnonymous,
        jira?.sidebarExperimentTemplates?.totalCount,
        jira?.userPreferences?.projectListRightPanelState,
        shouldDisplayCreateProject,
        jira,
        sidebarRefreshEnabled
    ]);
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $eJOHy.useState)();
    const prevPanelIdRef = (0, $eJOHy.useRef)();
    const delayRef = (0, $eJOHy.useRef)(undefined);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $eJOHy.useEffect)(()=>{
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $ham2H.PANEL_ID)) {
            /**
       * The right-sidebar is showing the templates panel...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== PANEL_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
       * If the right sidebar is not showing the templates panel,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            closeRightSidebar((0, $ham2H.PANEL_ID));
        }, [
        closeRightSidebar
    ]);
    if (localPanelId !== (0, $ham2H.PANEL_ID)) return null;
    if (isAnonymous) return null;
    if (!rootQueryRef?.jira) throw new Error('Failed to load sidebar content');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eHwMr.default), {
        refreshEnabled: (0, $epTsa.expValEquals)('grw-1532_jsm_jpd_project_directory_sidebar_refresh', 'cohort', 'variation'),
        rootQueryRef: rootQueryRef.jira
    });
};
const $05a216e053f3fb99$var$JiraProjectsTemplateListRightPanelContainer = (props)=>{
    const [sidebarRefreshConfig] = (0, $epTsa.UNSAFE_noExposureExp)('grw-1532_jsm_jpd_project_directory_sidebar_refresh');
    const sidebarRefreshEnabled = sidebarRefreshConfig.get('cohort', 'not-enrolled') === 'variation';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-layout-component",
        packageName: (0, $ham2H.PACKAGE_NAME),
        teamName: (0, $ham2H.TEAM_NAME),
        attributes: {
            sidebarVisualRefreshEnabled: sidebarRefreshEnabled
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($05a216e053f3fb99$var$JiraProjectsTemplateListRightPanel, {
        ...props,
        props: {
            ...props.props,
            sidebarRefreshEnabled: sidebarRefreshEnabled
        }
    }));
};
var $05a216e053f3fb99$export$2e2bcd8739ae039 = $05a216e053f3fb99$var$JiraProjectsTemplateListRightPanelContainer;

});
parcelRegister("dpe9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9757d02914316b30$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<638fe57df0f0306785938d443217587f>>
 * @relayHash dbb4fc405135e8a7a440f4a278aa8a4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51

var $37Ewn = parcelRequire("37Ewn");
const $9757d02914316b30$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAllowingEndUsersToAccessCustomTemplates"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isAnonymous"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = [
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    }, v6 = [
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "experimentKey",
            "value": "sidebarExperiment"
        }
    ], v7 = {
        "alias": "sidebarExperimentTemplates",
        "args": v6 /*: any*/ ,
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ]
    }, v8 = {
        "alias": "canCreateProject",
        "args": [
            v3 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
            }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
    }, v9 = {
        "condition": "isAllowingEndUsersToAccessCustomTemplates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "shouldDisplay",
                "args": [
                    v3 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "VIEW_PROJECT_CREATION_ENTRY"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectListViewTemplateItem",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "templateType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "productKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isProductLicensed"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "shortDescription"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isPremiumOnly"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canCreate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "recommendationSessionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "iconUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "iconDarkUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "previewUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "previewDarkUrl"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5ecb9c81810aa1fdab2dc5cd2d7a7132b51641fefbf041b495af8e5a823b8d51",
            "metadata": {},
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9757d02914316b30$var$node.hash = "021e8fae3a719490c175d29ba166dc66";
(0, $37Ewn.PreloadableQueryRegistry).set($9757d02914316b30$var$node.params.id, $9757d02914316b30$var$node);
var $9757d02914316b30$export$2e2bcd8739ae039 = $9757d02914316b30$var$node;

});

parcelRegister("ham2H", function(module, exports) {

$parcel$export(module.exports, "TEAM_NAME", () => $3a1532ebfbd963fa$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PACKAGE_NAME", () => $3a1532ebfbd963fa$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $3a1532ebfbd963fa$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_WIDTH_REFRESH", () => $3a1532ebfbd963fa$export$a191a221249cbcae);
$parcel$export(module.exports, "PANEL_ID", () => $3a1532ebfbd963fa$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $3a1532ebfbd963fa$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $3a1532ebfbd963fa$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $3a1532ebfbd963fa$export$29629758934356a6);

var $dNnxZ = parcelRequire("dNnxZ");

var $dUrLZ = parcelRequire("dUrLZ");
const $3a1532ebfbd963fa$export$d57b6b390e78d90f = 'helix';
const $3a1532ebfbd963fa$export$b8b9d90f9e5bd72b = 'jiraGrowthRecommendationsInProjectList';
const $3a1532ebfbd963fa$export$780035d9fe48eb32 = 365;
const $3a1532ebfbd963fa$export$a191a221249cbcae = 400;
const $3a1532ebfbd963fa$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $3a1532ebfbd963fa$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $3a1532ebfbd963fa$export$280536374592bda3 = 'recommendationsInProjectList';
const $3a1532ebfbd963fa$export$990484f4e8c06c90 = {
    BUSINESS: (0, $dNnxZ.Targets).JIRA_CORE,
    SOFTWARE: (0, $dNnxZ.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $dNnxZ.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $dNnxZ.Targets).JIRA_PRODUCT_DISCOVERY
};
const $3a1532ebfbd963fa$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("eHwMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3673d78736dc734$export$2e2bcd8739ae039);

var $9G9cn = parcelRequire("9G9cn");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $6J9k6 = parcelRequire("6J9k6");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $dzLcO = parcelRequire("dzLcO");

var $cNe2t = parcelRequire("cNe2t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9pWNg = parcelRequire("9pWNg");

var $g1NZW = parcelRequire("g1NZW");

var $1Yvty = parcelRequire("1Yvty");

var $6zXPf = parcelRequire("6zXPf");

var $ham2H = parcelRequire("ham2H");

var $3xRxU = parcelRequire("3xRxU");

var $jwXVX = parcelRequire("jwXVX");

var $hztG5 = parcelRequire("hztG5");

var $hIUJd = parcelRequire("hIUJd");

var $dBKLI = parcelRequire("dBKLI");
const $d3673d78736dc734$var$RecommendationsInProjectList = ({ rootQueryRef: rootQueryRef, refreshEnabled: refreshEnabled })=>{
    const [templatePreviewKey, setTemplatePreviewKey] = (0, $eJOHy.useState)(null);
    const environment = (0, $g1NZW.useEnvironment)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { methods: { open: openProjectCreate } } = (0, $9pWNg.useProjectCreateDrawer)();
    const buttonEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { projectListViewTemplates: projectListViewTemplates, userPreferences: userPreferences } = (0, $j4oe4.useFragment)((0, $9G9cn.default), rootQueryRef);
    const setProjectListRightPanelState = (0, $jwXVX.useSetProjectListRightPanelState)(userPreferences?.__id);
    const onCloseClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(buttonEvent, 'closeButton');
        setProjectListRightPanelState('CLOSED');
    }, [
        buttonEvent,
        setProjectListRightPanelState
    ]);
    const templates = (0, $eJOHy.useMemo)(()=>projectListViewTemplates?.nodes?.filter((template)=>!!template) ?? [], [
        projectListViewTemplates?.nodes
    ]);
    const templatePreviewRef = (0, $eJOHy.useMemo)(()=>templates.find((template)=>template.key === templatePreviewKey), [
        templatePreviewKey,
        templates
    ]);
    const recommendedProductIds = (0, $eJOHy.useMemo)(()=>Array.from(templates.reduce((acc, template)=>{
            const { isProductLicensed: isProductLicensed, productKey: productKey } = template;
            if (!isProductLicensed) acc.add((0, $ham2H.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]);
            return acc;
        }, new Set())), [
        environment,
        templates
    ]);
    const RefreshCloseButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $3xRxU.messages).closeButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            ...tooltipProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
                spacing: "spacious",
                label: ""
            }),
            "aria-label": formatMessage((0, $3xRxU.messages).closeButton),
            appearance: "subtle",
            onClick: onCloseClick
        }));
    const onMoreTemplatesClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(buttonEvent, 'moreTemplatesButton');
        openProjectCreate({
            showExperienceSelection: false,
            source: (0, $ham2H.PROJECT_CREATE_SOURCE)
        });
    }, [
        buttonEvent,
        openProjectCreate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        recommendedProductIds.length > 0 && fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsDirectorySidebar'
        }, {
            recommendedProductIds: recommendedProductIds,
            source: 'projectsDirectorySidebarSection'
        }, {
            sidebarVisualRefreshEnabled: refreshEnabled
        });
    }, [
        fireViewedUIEvent,
        recommendedProductIds,
        refreshEnabled
    ]);
    const isNav4Enabled = (0, $6zXPf.getWillShowNav4)(); /**
                                            * The future state for Nav 4 is that the panel slot will have its own border,
                                            * and panels should not apply custom borders.
                                            */ 
    const shouldUsePlatformPanelBorder = refreshEnabled && isNav4Enabled && (0, $7jTnu.fg)('platform_design_system_nav4_panel_default_border'); /**
                                                                                                                                   * When using the platform panel border, we need to offset the popup by 1 pixel or it covers the panel border.
                                                                                                                                   */ 
    const offset = shouldUsePlatformPanelBorder ? [
        0,
        1
    ] : [
        0,
        0
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: true,
        placement: "left-start",
        offset: offset,
        autoFocus: false,
        popupComponent: refreshEnabled ? $d3673d78736dc734$var$CustomPopupContainer : undefined,
        messageId: "projects-directory-templates-sidebar.ui.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                ...triggerProps,
                "aria-expanded": undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                id: "jira-project-list-side-panel",
                xcss: [
                    refreshEnabled ? $d3673d78736dc734$var$ExperimentSidebarContentStylesVariation : $d3673d78736dc734$var$ExperimentSidebarContentStyles,
                    refreshEnabled && !shouldUsePlatformPanelBorder && $d3673d78736dc734$var$ExperimentSidebarContentBorderStylesVariation,
                    /**
     * Changing to 100% width instead of a fixed width for the panel content,
     * otherwise enabling the platform panel border can introduce horizontal scrolling.
     */ (0, $7jTnu.fg)('platform_design_system_nav4_panel_default_border') && $d3673d78736dc734$var$ExperimentSidebarContentWidthStylesVariation
                ],
                ...(0, $7jTnu.fg)('jfp_a11y_autodev_fix_templates_dialog_role') ? {
                    role: 'dialog',
                    'aria-modal': 'false',
                    'aria-labelledby': 'templates-dialog-title'
                } : {}
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
                xcss: refreshEnabled && $d3673d78736dc734$var$headerBoxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
                xcss: refreshEnabled ? $d3673d78736dc734$var$TitleStylesVariation : $d3673d78736dc734$var$TitleStyles,
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                size: refreshEnabled ? 'small' : 'xsmall',
                id: (0, $7jTnu.fg)('jfp_a11y_autodev_fix_templates_dialog_role') ? 'templates-dialog-title' : undefined,
                as: (0, $7jTnu.fg)('jfp-a11y-team_autodev_header_fixes') ? 'h2' : undefined
            }, formatMessage((0, $3xRxU.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: !refreshEnabled && $d3673d78736dc734$var$ButtonBoxStyles
            }, refreshEnabled ? RefreshCloseButton : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
                    spacing: "spacious",
                    label: ""
                }),
                "aria-label": formatMessage((0, $3xRxU.messages).closeButton),
                "data-testId": "projects-directory-templates-sidebar.ui.close-templates-panel",
                appearance: "subtle",
                onClick: onCloseClick
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                as: "p",
                xcss: $d3673d78736dc734$var$SubtitleStyles
            }, formatMessage((0, $3xRxU.messages).subtitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
                as: "ul",
                xcss: $d3673d78736dc734$var$TemplateCardStackStyles
            }, templates.map((cardRef, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hztG5.TemplateCard), {
                    key: cardRef.key,
                    index: index,
                    dataRef: cardRef,
                    recommendedProductIds: recommendedProductIds,
                    setTemplatePreviewKey: setTemplatePreviewKey,
                    refreshEnabled: refreshEnabled
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: refreshEnabled && $d3673d78736dc734$var$moreTemplateLinkStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                spacing: "none",
                label: formatMessage((0, $3xRxU.messages).moreTemplatesLink),
                onClick: ()=>onMoreTemplatesClick()
            }, formatMessage((0, $3xRxU.messages).moreTemplatesLink))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
                attributes: {
                    templates: templates.map(({ key: key })=>key),
                    templateTypes: templates.map(({ templateType: templateType })=>templateType),
                    sidebarVisualRefreshEnabled: refreshEnabled
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dBKLI.JiraProjectListSidePanelSkipLink), null))),
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
                id: "template-preview-wrapper",
                packageName: (0, $ham2H.PACKAGE_NAME),
                teamName: (0, $ham2H.TEAM_NAME),
                attributes: {
                    sidebarVisualRefreshEnabled: refreshEnabled
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), null, templatePreviewRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
                duration: "medium"
            }, (fadeInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", fadeInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hIUJd.TemplatePreview), {
                    update: update,
                    previewRef: templatePreviewRef,
                    refreshEnabled: refreshEnabled
                })))))
    });
};
const $d3673d78736dc734$var$RecommendationsInProjectListContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "projectListTemplates",
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d3673d78736dc734$var$RecommendationsInProjectList, props));
const $d3673d78736dc734$var$TitleStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: 'color.text.subtle',
    position: 'relative'
});
const $d3673d78736dc734$var$ButtonBoxStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.050'
});
const $d3673d78736dc734$var$SubtitleStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: 'space.0'
});
const $d3673d78736dc734$var$ExperimentSidebarContentStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`,
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $ham2H.SIDEBAR_WIDTH)}px`,
    padding: 'space.300',
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'border-box'
}); // GRW-1532
const $d3673d78736dc734$var$CustomPopupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $hcewu.default)([
            "_1pfht94y _1e0c1ule _vchhusvi _nt751r31 _49pcglyw _1hvw1o36"
        ])
    }, children));
const $d3673d78736dc734$var$containerStyles = null;
const $d3673d78736dc734$var$moreTemplateLinkStyles = (0, $1DXK0.xcss)({
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    marginBlockStart: 'space.0',
    paddingInlineStart: 'space.200'
});
const $d3673d78736dc734$var$headerBoxStyles = (0, $1DXK0.xcss)({
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.100',
    marginBlockEnd: 'space.200'
});
const $d3673d78736dc734$var$TitleStylesVariation = (0, $1DXK0.xcss)({
    color: 'color.text',
    position: 'relative'
});
const $d3673d78736dc734$var$ExperimentSidebarContentStylesVariation = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`,
    width: '400px',
    overflow: 'auto',
    paddingBlock: 'space.300',
    paddingInline: 'space.100',
    backgroundColor: 'elevation.surface',
    boxSizing: 'border-box'
}); /**
     * The panel content does not need a hardcoded width, because the panel slot determines width.
     * The content should fill the slot.
     */ 
const $d3673d78736dc734$var$ExperimentSidebarContentWidthStylesVariation = (0, $1DXK0.xcss)({
    width: '100%'
});
const $d3673d78736dc734$var$ExperimentSidebarContentBorderStylesVariation = (0, $1DXK0.xcss)({
    borderLeftWidth: '1px',
    borderLeftStyle: 'solid',
    borderLeftColor: 'color.border'
});
const $d3673d78736dc734$var$TemplateCardStackStyles = (0, $1DXK0.xcss)({
    listStyle: 'none',
    justifyContent: 'start',
    padding: 'space.0',
    marginBlock: 'space.050'
});
var $d3673d78736dc734$export$2e2bcd8739ae039 = $d3673d78736dc734$var$RecommendationsInProjectListContainer;

});
parcelRegister("9G9cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ada358869d91fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7053b7eb6b4b3f2af19b7e28dc524520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $16ada358869d91fe$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "experimentKey",
                        "value": "sidebarExperiment"
                    }
                ],
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraProjectListViewTemplateItem",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.key"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "templateType"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.templateType"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "productKey"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.productKey"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isProductLicensed"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.isProductLicensed"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectsDirectoryTemplatesSidebar_TemplateCard"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "preview_projectsDirectoryTemplatesSidebar_TemplatePreview"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$16ada358869d91fe$var$node.hash = "cb3cd1eb69b348c8ecc62b322098e37b";
var $16ada358869d91fe$export$2e2bcd8739ae039 = $16ada358869d91fe$var$node;

});

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3xRxU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87dfd3929d8aa196$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $87dfd3929d8aa196$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "projects-directory-templates-sidebar.title",
        "defaultMessage": "Templates"
    },
    subtitle: {
        "id": "projects-directory-templates-sidebar.subtitle",
        "defaultMessage": "Preview a template for your next project"
    },
    moreTemplatesLink: {
        "id": "projects-directory-templates-sidebar.more-templates-link",
        "defaultMessage": "More templates"
    },
    closeButton: {
        "id": "projects-directory-templates-sidebar.close-button",
        "defaultMessage": "Close"
    },
    tryLozenge: {
        "id": "projects-directory-templates-sidebar.try-lozenge",
        "defaultMessage": "Try"
    },
    premiumLozenge: {
        "id": "projects-directory-templates-sidebar.premium-lozenge",
        "defaultMessage": "Premium"
    },
    productKeyBusinessLabelSpork: {
        "id": "projects-directory-templates-sidebar.product-key-business-label-spork",
        "defaultMessage": "Get Jira to use this template"
    },
    productKeySoftwareLabelSpork: {
        "id": "projects-directory-templates-sidebar.product-key-software-label-spork",
        "defaultMessage": "Get Jira to use this template"
    },
    productKeyServiceDeskLabel: {
        "id": "projects-directory-templates-sidebar.product-key-service-desk-label",
        "defaultMessage": "Get Jira Service Management to use this template"
    },
    productKeyProductDiscoveryLabel: {
        "id": "projects-directory-templates-sidebar.product-key-product-discovery-label",
        "defaultMessage": "Get Jira Product Discovery to use this template"
    },
    premiumTemplateDiscoveryLabelSpork: {
        "id": "projects-directory-templates-sidebar.premium-template-discovery-label-spork",
        "defaultMessage": "Upgrade to Jira Premium to use this template"
    },
    closeButtonTooltip: {
        "id": "projects-directory-templates-sidebar.close-button-tooltip",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("jwXVX", function(module, exports) {

$parcel$export(module.exports, "useSetProjectListRightPanelState", () => $2cca22b3e352a74a$export$f7872413c3847449);

var $9KAKd = parcelRequire("9KAKd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $ham2H = parcelRequire("ham2H");
const $2cca22b3e352a74a$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
const $2cca22b3e352a74a$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
    if (typeof userPreferencesRefId === 'string') {
        const record = store.get(userPreferencesRefId);
        record?.setValue(state, $2cca22b3e352a74a$var$PROJECT_LIST_RIGHT_PANEL_STATE);
    }
};
const $2cca22b3e352a74a$export$f7872413c3847449 = (userPreferencesRefId)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commit] = (0, $j4oe4.useMutation)((0, $9KAKd.default));
    const setRightPanelState = (0, $eJOHy.useCallback)((state)=>{
        commit({
            variables: {
                cloudId: cloudId,
                state: state
            },
            optimisticUpdater: (store)=>$2cca22b3e352a74a$var$relayStoreUpdater(store, userPreferencesRefId, state),
            updater: (store, { // @ts-expect-error TS-2339 - Property 'jira' does not exist on type 'setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation$data | null | undefined'.
            jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$2cca22b3e352a74a$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
            onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'userPreferences' does not exist on type '{ readonly userPreferences: { readonly setProjectListRightPanelState: { readonly errors: readonly { readonly extensions: { readonly statusCode: number | null | undefined; } | null | undefined; readonly message: string | null | undefined; }[] | null | undefined; readonly projectListRightPanelState: JiraProjectListRig...'.
            userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                const error = (errors ?? [])[0];
                if (!success || error) {
                    const errorMessage = `error on set project list right panel state: ${error.message}`;
                    const statusCode = error.extensions?.statusCode;
                    (0, $gYnSx.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateError',
                            packageName: (0, $ham2H.PACKAGE_NAME),
                            teamName: (0, $ham2H.TEAM_NAME)
                        }
                    });
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                    meta: {
                        id: 'jiraSetProjectListRightPanelStateMutationError',
                        packageName: (0, $ham2H.PACKAGE_NAME),
                        teamName: (0, $ham2H.TEAM_NAME)
                    }
                });
            }
        });
    }, [
        cloudId,
        commit,
        userPreferencesRefId
    ]);
    return setRightPanelState;
};

});
parcelRegister("9KAKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ffffb7e0445226$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f982c84219e38d14c162a90f7e73d838>>
 * @relayHash 932a6ab30b4abea8c4b298d0299ba01a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b
const $c2ffffb7e0445226$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b",
            "metadata": {},
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c2ffffb7e0445226$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
var $c2ffffb7e0445226$export$2e2bcd8739ae039 = $c2ffffb7e0445226$var$node;

});


parcelRegister("hztG5", function(module, exports) {

$parcel$export(module.exports, "TemplateCard", () => $aac9bb33bfbc1317$export$ba340e850b866867);

var $2Av5J = parcelRequire("2Av5J");

var $eJOHy = parcelRequire("eJOHy");

var $6X7AJ = parcelRequire("6X7AJ");

var $j4oe4 = parcelRequire("j4oe4");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $dhdXs = parcelRequire("dhdXs");

var $ciFJV = parcelRequire("ciFJV");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9pWNg = parcelRequire("9pWNg");

var $lgOFD = parcelRequire("lgOFD");

var $g1NZW = parcelRequire("g1NZW");

var $1Yvty = parcelRequire("1Yvty");

var $ham2H = parcelRequire("ham2H");

var $3xRxU = parcelRequire("3xRxU");

var $levud = parcelRequire("levud");

var $6vuHN = parcelRequire("6vuHN");

var $2P8LY = parcelRequire("2P8LY");
const $aac9bb33bfbc1317$export$ba340e850b866867 = ({ dataRef: dataRef, recommendedProductIds: recommendedProductIds, setTemplatePreviewKey: setTemplatePreviewKey, index: index, refreshEnabled: refreshEnabled })=>{
    const environment = (0, $g1NZW.useEnvironment)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { methods: { open: openProjectCreate } } = (0, $9pWNg.useProjectCreateDrawer)();
    const cardEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'card'
    });
    const cardHoveredEvent = createAnalyticsEvent({
        action: 'hovered',
        actionSubject: 'card'
    });
    const template = (0, $j4oe4.useFragment)((0, $2Av5J.default), dataRef);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { title: title, shortDescription: shortDescription, description: description, key: key, isProductLicensed: isProductLicensed, isPremiumOnly: isPremiumOnly, productKey: productKey, templateType: templateType, recommendationSessionId: recommendationSessionId, canCreate: canCreate } = template;
    const { shouldPromptJsmTrial: shouldPromptJsmTrial } = (0, $levud.checkShouldPromptJsmTrial)({
        templateKey: key,
        isProductLicensed: isProductLicensed,
        canCreate: canCreate
    });
    const [isJsmPremiumUpgradeModalOpen, setIsJsmPremiumUpgradeModalOpen] = (0, $eJOHy.useState)(false);
    const entryPoint = (0, $bbdV2.useEntryPoint)((0, $lgOFD.servicedeskStandardToPremiumModalEntryPoint), {});
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPoint.entryPointActions);
    const extensions = (0, $eJOHy.useMemo)(()=>{
        const mergedExtensions = (0, $2P8LY.buildCrossflowExtensions)({
            templateId: key,
            recommendationSessionId: recommendationSessionId,
            templateType: templateType
        });
        if (key === (0, $dhdXs.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY) && (0, $7jTnu.fg)('fix_advanced_itsm_recommendation_cross_flow')) Object.assign(mergedExtensions, {
            edition: 'premium'
        });
        return mergedExtensions;
    }, [
        key,
        recommendationSessionId,
        templateType
    ]);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(cardEvent, 'templateCard', {
            key: key,
            productKey: productKey,
            isProductLicensed: isProductLicensed,
            isPremiumOnly: isPremiumOnly,
            templateType: templateType,
            recommendationSessionId: recommendationSessionId,
            extensions: extensions
        });
        if (shouldPromptJsmTrial) {
            setIsJsmPremiumUpgradeModalOpen(true);
            return;
        }
        if (!isProductLicensed && crossFlow.isEnabled && (0, $ham2H.PROJECT_TYPE_TARGETS_MAP)[productKey] && (0, $ham2H.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]) {
            fireInteractedUIEvent({
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'templateCard'
            }, {
                recommendedProductIds: recommendedProductIds,
                recommendationSession: {
                    id: recommendationSessionId,
                    type: 'appRec'
                },
                targetProductId: (0, $ham2H.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey],
                source: 'projectsDirectorySidebarSection'
            });
            crossFlow.api.open({
                journey: (0, $6X7AJ.Journeys).GET_STARTED,
                targetProduct: (0, $ham2H.PROJECT_TYPE_TARGETS_MAP)[productKey],
                sourceComponent: 'projectsDirectorySidebar',
                sourceContext: 'templateCard',
                extensions: extensions
            });
            return;
        }
        openProjectCreate({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedProjectType: productKey.toLowerCase(),
            showExperienceSelection: false,
            defaultSelectedTemplateKey: key,
            source: (0, $ham2H.PROJECT_CREATE_SOURCE),
            recommendationSessionId: recommendationSessionId
        });
    }, [
        cardEvent,
        key,
        productKey,
        isProductLicensed,
        isPremiumOnly,
        templateType,
        recommendationSessionId,
        extensions,
        crossFlow,
        environment,
        openProjectCreate,
        fireInteractedUIEvent,
        shouldPromptJsmTrial,
        recommendedProductIds
    ]);
    const onPreviewDismiss = ()=>{
        setTemplatePreviewKey((current)=>{
            if (current === key) return null;
            return current;
        });
    };
    const onPreviewStart = ()=>{
        (0, $gCeeo.fireUIAnalytics)(cardHoveredEvent, 'templateCard', {
            key: key,
            productKey: productKey,
            isProductLicensed: isProductLicensed,
            templateType: templateType,
            isPremiumOnly: isPremiumOnly,
            sidebarVisualRefreshEnabled: refreshEnabled
        });
        setTemplatePreviewKey(key);
    };
    const templateLozenge = ()=>{
        if (!isProductLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $3xRxU.messages).tryLozenge));
        if (isPremiumOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $3xRxU.messages).premiumLozenge));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: refreshEnabled ? $aac9bb33bfbc1317$var$PaddedCardStylesVariation : $aac9bb33bfbc1317$var$PaddedCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        padding: refreshEnabled ? undefined : 'space.200',
        "data-testId": `projects-directory-templates-sidebar.ui.template-card-${index}`,
        xcss: refreshEnabled ? $aac9bb33bfbc1317$var$CardStylesVariation : $aac9bb33bfbc1317$var$CardStyles,
        "aria-description": description,
        onFocus: onPreviewStart,
        onBlur: onPreviewDismiss,
        onClick: onClick,
        onMouseEnter: onPreviewStart,
        onMouseLeave: onPreviewDismiss,
        tabIndex: 0,
        ...shouldPromptJsmTrial && {
            ref: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6vuHN.default), {
        keyRef: template,
        refreshEnabled: refreshEnabled
    }), refreshEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        as: "div",
        space: "space.025",
        xcss: $aac9bb33bfbc1317$var$TemplateTextContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $aac9bb33bfbc1317$var$TitleStylesVariation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $aac9bb33bfbc1317$var$TitleTextStyles
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span"
    }, templateLozenge())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "p",
        xcss: $aac9bb33bfbc1317$var$DescriptionStyles
    }, shortDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        as: "div",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $aac9bb33bfbc1317$var$TitleStyles
    }, `${title} `, templateLozenge()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "p",
        xcss: $aac9bb33bfbc1317$var$DescriptionStyles
    }, shortDescription))))), isJsmPremiumUpgradeModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "standard-to-premium-modal",
        packageName: "jira-cmdb-upsell-page",
        teamName: "ITOps Mithril" // assigning to Mithril for the experiment
        ,
        entryPointActions: entryPoint.entryPointActions,
        runtimeProps: {
            onClose: ()=>{
                setIsJsmPremiumUpgradeModalOpen(false);
            },
            origin: 'templateCard'
        }
    }));
};
const $aac9bb33bfbc1317$var$PaddedCardStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    paddingBlock: 'space.100'
});
const $aac9bb33bfbc1317$var$CardStyles = (0, $1DXK0.xcss)({
    width: '100%',
    textAlign: 'left',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    ':hover': {
        background: 'elevation.surface.overlay',
        boxShadow: 'elevation.shadow.overlay'
    },
    ':focus': {
        background: 'elevation.surface.overlay',
        boxShadow: 'elevation.shadow.overlay'
    }
});
const $aac9bb33bfbc1317$var$TitleStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text'
});
const $aac9bb33bfbc1317$var$DescriptionStyles = (0, $1DXK0.xcss)({
    margin: '0',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
// GRW-1532
const $aac9bb33bfbc1317$var$TitleStylesVariation = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text',
    display: 'flex',
    columnGap: 'space.100',
    flexDirection: 'row',
    alignItems: 'center'
});
const $aac9bb33bfbc1317$var$TitleTextStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $aac9bb33bfbc1317$var$TemplateTextContentStyles = (0, $1DXK0.xcss)({
    minWidth: '0'
});
const $aac9bb33bfbc1317$var$CardStylesVariation = (0, $1DXK0.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.200',
    width: '100%',
    textAlign: 'left',
    backgroundColor: 'elevation.surface',
    position: 'relative',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':focus': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        zIndex: 'card'
    }
});
const $aac9bb33bfbc1317$var$PaddedCardStylesVariation = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("2Av5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9183c0d816c7ed6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<937e7c02b5338fe3a29e9082749796e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d9183c0d816c7ed6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "card_projectsDirectoryTemplatesSidebar_TemplateCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "shortDescription"
            },
            "action": "THROW",
            "path": "shortDescription"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW",
            "path": "description"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isProductLicensed"
            },
            "action": "THROW",
            "path": "isProductLicensed"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isPremiumOnly"
            },
            "action": "THROW",
            "path": "isPremiumOnly"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canCreate"
            },
            "action": "THROW",
            "path": "canCreate"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "productKey"
            },
            "action": "THROW",
            "path": "productKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "recommendationSessionId"
            },
            "action": "THROW",
            "path": "recommendationSessionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "templateType"
            },
            "action": "THROW",
            "path": "templateType"
        },
        {
            "kind": "FragmentSpread",
            "name": "icon_projectsDirectoryTemplatesSidebar_CardIcon"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$d9183c0d816c7ed6$var$node.hash = "cb4c455ffef14c7b53983efd2af43579";
var $d9183c0d816c7ed6$export$2e2bcd8739ae039 = $d9183c0d816c7ed6$var$node;

});

parcelRegister("lgOFD", function(module, exports) {

$parcel$export(module.exports, "servicedeskStandardToPremiumModalEntryPoint", () => $241c353b91a6a21b$export$d21d0874477624e6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $241c353b91a6a21b$export$d21d0874477624e6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("kkbl5")), {
        moduleId: "8d5c4464",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kkbl5", function(module, exports) {

let $ecbe78a273aefde5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ecbe78a273aefde5$var$load("ffQaD"),
    $ecbe78a273aefde5$var$load("kvRbA"),
    $ecbe78a273aefde5$var$load("95Tyq")
]).then(()=>parcelRequire('hSd23'));

});


parcelRegister("levud", function(module, exports) {

$parcel$export(module.exports, "checkShouldPromptJsmTrial", () => $56528d0735ec527e$export$aa1475d77bc9ab5f);

var $dhdXs = parcelRequire("dhdXs");

var $7jTnu = parcelRequire("7jTnu");
const $56528d0735ec527e$export$aa1475d77bc9ab5f = ({ templateKey: templateKey, isProductLicensed: isProductLicensed, canCreate: canCreate })=>{
    return {
        shouldPromptJsmTrial: templateKey === (0, $dhdXs.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY) && isProductLicensed && !canCreate && (0, $7jTnu.fg)('jsm_it_service_management_advanced_template')
    };
};

});

parcelRegister("6vuHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef08fa94313c0703$export$2e2bcd8739ae039);

var $3bDtn = parcelRequire("3bDtn");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8wyVH = parcelRequire("8wyVH");
const $ef08fa94313c0703$export$f4619d70a16e5ea0 = ({ keyRef: keyRef, refreshEnabled: refreshEnabled })=>{
    const { iconUrl: iconUrl, iconDarkUrl: iconDarkUrl } = (0, $j4oe4.useFragment)((0, $3bDtn.default), keyRef);
    if (!iconUrl || !iconDarkUrl) return null;
    return refreshEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        alt: "",
        src: iconUrl,
        srcDark: iconDarkUrl,
        className: (0, $hcewu.default)([
            "_2rko1y44 _1bsbzwfg _4t3izwfg"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef08fa94313c0703$var$IconImage, {
        alt: "",
        src: iconUrl,
        srcDark: iconDarkUrl
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef08fa94313c0703$var$IconImage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $8wyVH.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _1bsb1ylp _4t3i1ylp",
            __cmplp.className
        ])
    });
});
const $ef08fa94313c0703$var$ImageVariationStyles = null;
var $ef08fa94313c0703$export$2e2bcd8739ae039 = $ef08fa94313c0703$export$f4619d70a16e5ea0;

});
parcelRegister("3bDtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0beaa984ea4bb68f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fd4936ca5f864fb79a486e481337d84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0beaa984ea4bb68f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "icon_projectsDirectoryTemplatesSidebar_CardIcon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        },
        {
            "kind": "ScalarField",
            "name": "iconDarkUrl"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$0beaa984ea4bb68f$var$node.hash = "c402fd47c91e565afa2bde202876eaf8";
var $0beaa984ea4bb68f$export$2e2bcd8739ae039 = $0beaa984ea4bb68f$var$node;

});


parcelRegister("2P8LY", function(module, exports) {

$parcel$export(module.exports, "buildCrossflowExtensions", () => $2058b44d75478124$export$11382497cf741299);

var $izzcG = parcelRequire("izzcG");
const $2058b44d75478124$export$11382497cf741299 = (args)=>{
    const { templateId: templateId, recommendationSessionId: recommendationSessionId, templateType: templateType } = args;
    const provisioningExtensions = (0, $izzcG.createProvisioningPageExtensions)({
        actions: {
            primary: {
                behaviour: (0, $izzcG.Behaviours).LAND,
                prompt: (0, $izzcG.Prompts).NEXT,
                options: {
                    targetTab: (0, $izzcG.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateType
                    }
                }
            }
        }
    });
    const recoExtensions = (0, $izzcG.createRecommendationContextExtensions)({
        recommendationSessionId: recommendationSessionId,
        entityId: templateId
    });
    const mergedExtensions = {};
    Object.assign(mergedExtensions, provisioningExtensions, recoExtensions);
    return mergedExtensions;
};

});


parcelRegister("hIUJd", function(module, exports) {

$parcel$export(module.exports, "TemplatePreview", () => $88f0181eb92fe2d9$export$48a171bbad47b95a);

var $kqfQR = parcelRequire("kqfQR");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8wyVH = parcelRequire("8wyVH");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $806LH = parcelRequire("806LH");

var $dzLcO = parcelRequire("dzLcO");

var $cUxaS = parcelRequire("cUxaS");

var $6zXPf = parcelRequire("6zXPf");

var $ham2H = parcelRequire("ham2H");
const $88f0181eb92fe2d9$var$usePreviewWidth = ()=>{
    const leftSidebarState = (0, $cUxaS.useLeftSidebarState)();
    const leftSidebarWidth = leftSidebarState.isCollapsed ? 0 : leftSidebarState.width; // left side nav gets automatically closed at 64rem and leftSidebarState no longer accurately reflects the state
    const isMobileView = globalThis.window && !globalThis.window.matchMedia('(min-width: 64rem)').matches;
    const leftSidebarHidden = isMobileView || !(0, $6zXPf.getWillShowNav4)(); // Temporary workaround to panel bug that enforces 365px width below 48rem
    const sidebarWidth = globalThis.window && globalThis.window.matchMedia('(min-width: 48rem)').matches ? (0, $ham2H.SIDEBAR_WIDTH_REFRESH) : 365;
    return (globalThis.window?.innerWidth || 0) - sidebarWidth - (leftSidebarHidden ? 0 : leftSidebarWidth);
};
const $88f0181eb92fe2d9$export$48a171bbad47b95a = ({ update: update, previewRef: previewRef, refreshEnabled: refreshEnabled })=>{
    const { title: title, description: description, key: key, previewUrl: previewUrl, previewDarkUrl: previewDarkUrl } = (0, $j4oe4.useFragment)((0, $kqfQR.default), previewRef);
    // Required to update the Popup location when the trigger has moved during side nav animation
    (0, $eJOHy.useEffect)(()=>{
        if (update) update();
    }, [
        update
    ]);
    const previewWidth = $88f0181eb92fe2d9$var$usePreviewWidth();
    if (previewWidth < 300) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $88f0181eb92fe2d9$var$TemplatePreviewWrapperStyles,
            !refreshEnabled && $88f0181eb92fe2d9$var$WidthStyles
        ],
        style: {
            width: refreshEnabled ? previewWidth : undefined
        }
    }, refreshEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        className: (0, $hcewu.default)([
            "_1bsb12it _p12f12hx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $88f0181eb92fe2d9$var$PreviewWrapperStyles,
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        xcss: $88f0181eb92fe2d9$var$TextContainerStylesVariation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large",
        as: "span"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium",
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $88f0181eb92fe2d9$var$ImageWrapperStylesVariation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88f0181eb92fe2d9$var$PreviewImage, {
        src: previewUrl,
        key: key,
        alt: "",
        srcDark: previewDarkUrl
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88f0181eb92fe2d9$var$TemplateAreaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $88f0181eb92fe2d9$var$PreviewWrapperStyles,
        space: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100",
        xcss: $88f0181eb92fe2d9$var$TextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $88f0181eb92fe2d9$var$TitleStyles
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "p",
        xcss: $88f0181eb92fe2d9$var$DescriptionStyles
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $88f0181eb92fe2d9$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88f0181eb92fe2d9$var$PreviewImage, {
        src: previewUrl,
        key: key,
        alt: "",
        srcDark: previewDarkUrl
    })))));
};
// GRW-1532 START
const $88f0181eb92fe2d9$var$templateAreaContainerVariationStyles = null;
const $88f0181eb92fe2d9$var$TextContainerStylesVariation = (0, $1DXK0.xcss)({
    color: 'color.text',
    textAlign: 'center'
});
const $88f0181eb92fe2d9$var$ImageWrapperStylesVariation = (0, $1DXK0.xcss)({
    aspectRatio: '436/360',
    maxHeight: '360px'
}); // GRW-1532 END
const $88f0181eb92fe2d9$var$TemplatePreviewWrapperStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $dzLcO.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)} - 4px)`,
    backgroundColor: 'elevation.surface',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    ':empty': {
        display: 'none'
    }
});
const $88f0181eb92fe2d9$var$WidthStyles = (0, $1DXK0.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100vw - ${(0, $ham2H.SIDEBAR_WIDTH)}px)`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88f0181eb92fe2d9$var$TemplateAreaContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb12it _1tku1ssb",
            __cmplp.className
        ])
    });
});
const $88f0181eb92fe2d9$var$ImageWrapperStyles = (0, $1DXK0.xcss)({
    aspectRatio: '100/62'
});
const $88f0181eb92fe2d9$var$TextContainerStyles = (0, $1DXK0.xcss)({
    color: 'color.text'
});
const $88f0181eb92fe2d9$var$TitleStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
const $88f0181eb92fe2d9$var$DescriptionStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    margin: '0'
});
const $88f0181eb92fe2d9$var$PreviewWrapperStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88f0181eb92fe2d9$var$PreviewImage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $8wyVH.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5ral1f51 _rsufjp4b _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqfQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7974145eab25df04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7489b2f76248bf4f8fd236f165f98f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7974145eab25df04$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preview_projectsDirectoryTemplatesSidebar_TemplatePreview",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW",
            "path": "description"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "previewUrl"
            },
            "action": "THROW",
            "path": "previewUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "previewDarkUrl"
            },
            "action": "THROW",
            "path": "previewDarkUrl"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$7974145eab25df04$var$node.hash = "83f2fe24a77e391a2bf8c4e6b7ad6e3b";
var $7974145eab25df04$export$2e2bcd8739ae039 = $7974145eab25df04$var$node;

});


parcelRegister("dBKLI", function(module, exports) {

$parcel$export(module.exports, "JiraProjectListSidePanelSkipLink", () => $fe53514663740a8a$export$32072395400d2f38);

var $lRq8t = parcelRequire("lRq8t");

var $dzLcO = parcelRequire("dzLcO");

var $9Ee9T = parcelRequire("9Ee9T");
const $fe53514663740a8a$export$32072395400d2f38 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $dzLcO.useCustomSkipLink)('jira-project-list-side-panel', formatMessage((0, $9Ee9T.default).skipToRightSidePanel), 4);
    return null;
};

});
parcelRegister("9Ee9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f70963ea356a3c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $13f70963ea356a3c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    skipToRightSidePanel: {
        "id": "projects-directory-templates-sidebar.skip-link.skip-to-right-side-panel",
        "defaultMessage": "Skip to Side Panel"
    }
});

});





//# sourceMappingURL=projects-directory-templates-sidebar.10d9058b.js.map
